/* Program Name: UserProxy.js
 **  Description: a navigation bar that appears upon proxy connection. Allows user
 **               to perform proxy related actions
 **
 ** Project    Date        Who  Comments
 ** ---------  ----------  ---  ---------------------------------------------------
 ** SD6391     1/22/2025   SGS  Added useProxy Context.
 *********************************************************************************/

/**React imports */
import React, { useRef } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'

/** React Router imports */
import { useHistory } from 'react-router-dom'

/**MUI imports */
import { AppBar, Toolbar } from '@mui/material'
import { ContentCopy } from '@mui/icons-material'

/**ezPOP components */
import { FlexBoxFull, FlexOne } from '../CustomDivs'
import {
  ErrorButton,
  PrimaryButton,
  SquarePrimaryButton,
} from '../ActionColorButtons'

/** API imports */
import { unProxyUser, giveCartProxy } from '../../../API/generalAPI'

/** Context imports */
import { useCart } from '../../../Context/CartContext'
import { useProxy } from '../../../Context/ProxyContext'
import { useAlert } from '../../../Context/AlertContext'

const UserProxy = ({ proxyUser, getMetaData, getLookUp, copyMessage }) => {
  /****************************************************************************/
  /**Local Variables */

  //Context end point to use the application alert system
  const alert = useRef(useAlert())
  //Context end point that controls proxy related actions
  const proxy = useProxy()
  //Context end point to connect to react router tools
  const history = useHistory()
  //Context end point to fire cart tally in header
  const { getCartCnt } = useCart()

  /******************************************************************************/
  /**Handle Unproxy*/
  /******************************************************************************/
  /** sets the current user to "unproxy" the selected user
   */
  const handleUnProxy = () => {
    unProxyUser()
      .then((response) => {
        alert.current.postAjaxAlert(response.data.meta[0])

        getMetaData()
        getCartCnt()

        history.push('/')
        proxy.stateReload()
      })
      .catch((error) => {
        alert.current.errorMessage(error.message)
      })
  }

  /******************************************************************************/
  /**Handle Pass Cart Proxy*/
  /******************************************************************************/
  /** handles transfering of cart ownership to proxied user
   */
  const handlePassCartProxy = () => {
    giveCartProxy(proxyUser.id)
      .then((response) => {
        getCartCnt()
        history.push('/')
        alert.current.postAjaxAlert(response.data.meta[0])
      })
      .catch((error) => {
        alert.current.errorMessage(error.message)
      })
      .then(() => {
        getMetaData()
      })
  }

  return (
    <AppBar position="sticky" sx={{ background: '#222', top: '48px' }}>
      <Toolbar variant="dense" sx={{ paddingLeft: 32, paddingRight: 32 }}>
        <FlexBoxFull>
          <FlexOne />
          <h3
            style={{ color: '#FFF', margin: 0, lineHeight: '48px' }}
          >{`Proxied as: ${proxyUser.dispName}`}</h3>
          <FlexOne style={{ display: 'flex' }}>
            <FlexOne />
            <PrimaryButton onClick={handlePassCartProxy}>
              Pass Cart
            </PrimaryButton>
            <div
              style={{ fontSize: '12px', color: '#FFF', lineHeight: '16px' }}
            >
              <div>{`ID: ${proxyUser.login}`}</div>
              <div>{`Username: ${proxyUser.dispName}`}</div>
              <div>{`Email: ${proxyUser.email}`}</div>
            </div>
            <CopyToClipboard
              text={`User ID: ${proxyUser.login} \nUsername: ${proxyUser.dispName} \nEmail: ${proxyUser.email}`}
              onCopy={copyMessage}
            >
              <SquarePrimaryButton>
                <ContentCopy />
              </SquarePrimaryButton>
            </CopyToClipboard>
            <ErrorButton onClick={handleUnProxy}>Unproxy</ErrorButton>
          </FlexOne>
        </FlexBoxFull>
      </Toolbar>
    </AppBar>
  )
}

export default UserProxy
